import(/* webpackMode: "eager" */ "/app/app/pools/[protocol]/[pair]/error.tsx");
